import { PreferredTimeValue } from '@/types';

export interface PreferredDayOption {
  text: string;
  date: string;
  value: string;
}
export interface PreferredTimeOption {
  text: string;
  value: PreferredTimeValue;
}

export const WEEK_DAYS = 7;

function getNextDay(index): Date {
  const currentDay = new Date();
  currentDay.setDate(currentDay.getDate() + index);
  return currentDay;
}

export const getPreferredDayOptions = () => {
  const weekdayMapping = {
    1: 'localLanding.contactForm.favoriteDay.monday',
    2: 'localLanding.contactForm.favoriteDay.tuesday',
    3: 'localLanding.contactForm.favoriteDay.wednesday',
    4: 'localLanding.contactForm.favoriteDay.thursday',
    5: 'localLanding.contactForm.favoriteDay.friday',
  };

  const options: any = [];

  for (let i = 1; i <= WEEK_DAYS; i++) {
    const followingDay = new Date(getNextDay(i));
    const weekDay = followingDay.getDay();
    if (weekDay >= 1 && weekDay <= 5) {
      const formattedDayText = followingDay.toLocaleDateString('de-CH', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      const formatttedDayValue = followingDay.toLocaleDateString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      options.push({
        text: weekdayMapping[weekDay],
        date: formattedDayText,
        value: new Date(formatttedDayValue).toISOString(),
      });
    }
  }
  return options;
};

export const preferredTimeOptions: PreferredTimeOption[] = [
  {
    text: '08:00 – 12:00',
    value: PreferredTimeValue.Morning,
  },
  {
    text: '12:00 – 13:00',
    value: PreferredTimeValue.Noon,
  },
  {
    text: '13:00 – 17:00',
    value: PreferredTimeValue.Afternoon,
  },
  {
    text: '17:00 – 18:00',
    value: PreferredTimeValue.Evening,
  },
];

export const TEXT_MAX_LENGTH = 255;

export interface PhoneData {
  valid: boolean;
  number: null | string;
}
type FirstName = null | string;
type Lastname = null | string;
type PreferredDay = null | string;
type PreferredTime = null | PreferredTimeValue;

export interface ContactModalData {
  phoneData: PhoneData;
  firstName: FirstName;
  lastName: Lastname;
  preferredDay: PreferredDay;
  preferredTime: PreferredTime;
  preferredTimeOptions: PreferredTimeOption[];
  preferredDayOptions: PreferredDayOption[];
  isPlatformIs24: boolean;
  isPlatformHg: boolean;
  isFormSubmitting: boolean;
  previousFormData: {
    phoneNumber: null | string;
    firstName: FirstName;
    lastName: Lastname;
    preferredDay: PreferredDay;
    preferredTime: PreferredTime;
  };
}
